module.exports = __webpack_public_path__ + "static/media/text.86abd136.svg";